// extracted by mini-css-extract-plugin
export default {"select":"MySelect_select__UCMnw"};